import React from "react"

const settingsNavItemNames = ["Profile", "Billing", "Connected Apps"]

const renderSettingDashTopNav = (
    items = [],
    selectedSettingsTab,
    setSelectedSettingsTab,
) => {
    const mappedSettingsNavItems = items
        .filter(item => item !== "Plans")
        .map((item, i) => {
            const itemLowerCase = item.toLowerCase()
            return (
                <li key={i}>
                    <a
                        href="javascript:;"
                        onClick={() => setSelectedSettingsTab(itemLowerCase)}
                        className={
                            selectedSettingsTab === itemLowerCase
                                ? "active settings-active"
                                : ""
                        }
                    >
                        {item}
                    </a>
                </li>
            )
        })

    return <ul>{mappedSettingsNavItems}</ul>
}

renderSettingDashTopNav(settingsNavItemNames)

const SettingsDashTopNav = ({
    selectedSettingsTab,
    setSelectedSettingsTab,
}) => (
    <div className="dash-nav settings-top-nav-container">
        {renderSettingDashTopNav(
            settingsNavItemNames,
            selectedSettingsTab,
            setSelectedSettingsTab,
        )}
    </div>
)

export default SettingsDashTopNav



// WEBPACK FOOTER //
// ./src/components/settings_top_nav.jsx